import { ToursEnum } from './../../../enums/tour/tours.enum';
import { LocalStorageEnum } from './../../../enums/utils/local-storage.enum';
import { PanelUtilitiesActions } from 'src/app/models/panel-utilities';
import { firstValueFrom } from 'rxjs';
import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';


export const workSchedulesOnlyExpertSteps: (tourSteps: TourSteps) => Step.StepOptions[] =
({steps, buttons, services, cb}: TourSteps): Step.StepOptions[] => {
  return [
    {
      ...steps.default,
      id: 'workSchedules1',
      title: 'Horarios',
      text: `Ingresa al módulo "Horarios".`,
      attachTo: {
        element: '.panel-item-1',    // @ts-ignore
        on: 'bottom'
      },
      advanceOn: {
        selector: '.panel-item-1',
        event: 'click',
      },
      canClickTarget: true,
      buttons: [{...buttons.cancel}],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          services.utilitiesService.existElementInDom().byClassName('panel-item-1').subscribe({
            next: async (): Promise<void> => await firstValueFrom(services.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(false))),
            complete: async (): Promise<void> => {
              await firstValueFrom(services.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(true)));
              resolve(true);
            }
          });
        });
      }
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep3',
      title: 'Cierra el panel lateral',
      text: `Haz clic para ocultar el panel, de esa forma podrás tener mejor visibilidad de los horarios.`,
      attachTo: {
        element: '.icon-hide-menu',
        on: 'bottom'
      },
      advanceOn: {
        selector: '.icon-hide-menu',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      // work-schedules
      ...steps.default,
      id: 'workSchedules3',
      title: 'Horario inicial',
      text: 'Por defecto tenemos un horario precreado con un horario laboral de lunes a sábado.',
      attachTo: {
        element: '.work-schedules',
        on: 'top'
      },
      canClickTarget: false,
      scrollTo: undefined,
    },
    {
      // schedules-items
      ...steps.default,
      id: 'workSchedules11',
      title: 'Define los días y horas disponibles del grupo',
      text: 'En esta sección podrás definir los días y horarios disponibles para citas.',
      canClickTarget: false,
      attachTo: {
        element: '.schedules-items',    // @ts-ignore
        on: 'bottom',
      },
      scrollTo: undefined,
    },
    {
      ...steps.default,
      id: 'workSchedules12',
      title: 'Selecciona el día',
      text: 'Presiona sobre el nombre del día para habilitarlo.',
      attachTo: {
        element: '.shepherd-item-1 .shepherd-check label .ant-checkbox + span',
        on: 'right',
      },
      advanceOn: {
        selector: '.shepherd-item-1 .shepherd-check label .ant-checkbox + span',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
      modalOverlayOpeningPadding: 0
    },
    {
      // shepherd-time-start
      ...steps.default,
      id: 'workSchedules13',
      title: 'Hora inicio',
      text: 'Aquí podrás ingresar la hora de inició.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-item-1 .shepherd-time-start',    // @ts-ignore
        on: 'bottom',
      },
    },
    {
      // shepherd-time-end
      ...steps.default,
      id: 'workSchedules14',
      title: 'Hora fin',
      text: 'Aquí podrás ingresar la hora de fin.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-item-1 .shepherd-time-end',    // @ts-ignore
        on: 'bottom',
      },
    },
    {
      // shepherd-time-delete
      ...steps.default,
      id: 'workSchedules15',
      title: 'Eliminar horario',
      text: 'Aquí podrás eliminar un horario.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-item-1 .shepherd-time-delete',    // @ts-ignore
        on: 'bottom',
      },
    },
    {
      // shepherd-time-plus-icon
      ...steps.default,
      id: 'workSchedules16',
      title: 'Agregar horario',
      text: 'Puedes definir tantos horarios como deses por día, la única condición es que los rangos de horarios no deben empalmarse.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-item-1 .shepherd-time-plus-icon',    // @ts-ignore
        on: 'bottom',
      },
    },
    {
      // schedules-exceptions
      ...steps.default,
      id: 'workSchedules17',
      title: 'Excepciones',
      text: 'Puedes definir rangos de días y horas en los cuales no estará disponible para citas.',
      canClickTarget: false,
      attachTo: {
        element: '.schedules-exceptions',
        on: 'top',
      },
      scrollTo: undefined,
    },
    {
      // plus-icon
      ...steps.default,
      id: 'workSchedules18',
      title: 'Agregar excepción',
      text: 'Para agregar una excepción. Da clic en el botón.',
      attachTo: {
        element: '.schedules-exceptions .schedules-exceptions-plus-icon',
        on: 'left',
      },
      advanceOn: {
        selector: '.schedules-exceptions .schedules-exceptions-plus-icon',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      // shepherd-range-picker
      ...steps.default,
      id: 'workSchedules19',
      title: 'Días de excepción',
      text: 'En esta sección podrás agregar los días en los cuales no estará disponibles para citas.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-range-picker',
        on: 'top',
      },
    },
    {
      // shepherd-exception-modal-range-text
      ...steps.default,
      id: 'workSchedules20',
      title: 'Rango de fechas',
      text: 'Aquí podrás visualizar cual fue el rango de fechas que has seleccionado anteriormente.',
      // canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-range-text',
        on: 'top',
      },
    },
    {
      // shepherd-exception-modal-range-recurring
      ...steps.default,
      id: 'workSchedules21',
      title: 'Utilizar de forma recurrente',
      text: 'Si habilitas esta opción el sistema repetirá esta excepción cada año.',
      // canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-range-recurring',
        on: 'top',
      },
    },
    {
      ...steps.default,
      id: 'workSchedules22',
      title: 'Agregar horas de excepción',
      text: 'Habrá ocasiones en las cuales deseas agregar una excepción para algunas horas en específico. aquí puedes definir esos horarios.',
      attachTo: {
        element: '.shepherd-exception-modal-add-hour',
        on: 'top',
      },
      advanceOn: {
        selector: '.shepherd-exception-modal-add-hour',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      ...steps.default,
      id: 'workSchedules23',
      title: 'Hora inicio',
      text: 'Aquí ingresaras la hora en la cual comenzará la excepción.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-time-start',
        on: 'top',
      }
    },
    {
      ...steps.default,
      id: 'workSchedules24',
      title: 'Hora fin',
      text: 'Aquí ingresaras la hora en la cual finalizará la excepción.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-time-end',
        on: 'top',
      },
    },
    {
      // shepherd-modal-exception-add
      ...steps.default,
      id: 'workSchedules25',
      title: 'Eliminar horario',
      text: 'También podrás eliminar horarios de la excepción.',
      canClickTarget: false,
      attachTo: {
        element: '.shepherd-exception-modal-time-delete',
        on: 'top',
      },
    },
    {
      // shepherd-modal-exception-add
      ...steps.default,
      id: 'workSchedules26',
      title: 'Agregar excepción',
      text: 'Da clic para agregar la excepción.',
      attachTo: {
        element: '.shepherd-exception-modal-add',
        on: 'top',
      },
      advanceOn: {
        selector: '.shepherd-exception-modal-add',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      ...steps.default,
      id: 'workSchedules28',
      title: 'Crear horario',
      text: 'Una vez que hayas ingresado el horario tendrás que dar clic en el botón para poder guardar los datos.',
      canClickTarget: false,
      attachTo: {
        element: '.btn-save-group',
        on: 'top',
      },
      buttons: [
        {
          text: 'Entendido',
          // tslint:disable-next-line:typedef
          action(): void  {
            cb('createWorkSchedule');
            if (services.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.EXPERT_SCHEDULES) {
              // Si viene de la página de tours, le da la opción de mantenerse aquí o ir al listado de tours
              this.next();
            } else {
              // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de crear paciente
              this.complete();
            }
          },
        },
        {...buttons.cancel},
      ]
    },
    {
      ...steps.default,
      id: 'workSchedules29',
      title: 'Tour finalizado',
      // text: '¡Muy bien!. Ya conoces la forma de registrar sucursales, ahora solo te queda registrarlas.',
      text: '¡Muy bien!. Has finalizado el tour de "Registrar horario".',
      canClickTarget: false,
      buttons: [
        {
          // tslint:disable-next-line:typedef
          action(): void {
            cb('goToTours');
          },
          text: 'Ir al listado de tours',
          classes: 'shepherd-button shepherd-button-secondary',
        },
        {
          // tslint:disable-next-line:typedef
          action(): void {
            cb('keepMeHere');
          },
          text: 'Mantenerme aquí'
        },
        {...buttons.cancel}
      ]
    }
  ];
};
